// extracted by mini-css-extract-plugin
module.exports = {"header":"CronJobsSection_header__6i4EW","content":"CronJobsSection_content__2Tphz"};